import * as React from 'react';
import { observer } from 'mobx-react';
import { useCallback, useEffect, useRef, useState } from 'react';

import { classNames } from 'uitk-react-utils';

import { useStores } from 'utility/hooks';
import { JourneyInfo, JourneySummary } from '.';
import { ToggleLink } from 'components/shared';
import { focusElement } from 'utility';

interface SummaryAndInfoProps {
  itemIndex?: number;
}

export const SummaryAndInfo = observer(({ itemIndex }: SummaryAndInfoProps) => {
  const { flightsSelectedJourneyReviewStore } = useStores();
  const journeyInfoRef = useRef(null);
  const [isOpen, setOpenState] = useState(false);
  const handleActionClick = useCallback(() => setOpenState(isOpen => !isOpen), []);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        focusElement(journeyInfoRef);
      }, 50);
    }
  });

  if (
    flightsSelectedJourneyReviewStore &&
    itemIndex !== undefined &&
    flightsSelectedJourneyReviewStore.flightsSelectedJourneyReviewItem(itemIndex)
  ) {
    // TODO: this should be removed once sidesheet starts passing values in the components in FSR flow
    const {
      flightsJourneySummary,
      flightsJourneyInformation,
      flightsJourneyPolicies
    } = flightsSelectedJourneyReviewStore.flightsSelectedJourneyReviewItem(itemIndex);
    if (!flightsJourneyInformation && !flightsJourneySummary) {
      return null;
    }

    const toggleClassNames = classNames('all-x-padding-three', 'all-y-padding-one', {
      'all-l-margin-six': isOpen
    });

    return (
      <>
        {isOpen ? (
          <JourneyInfo journeyInfoRef={journeyInfoRef} flightsJourneyInformation={flightsJourneyInformation} />
        ) : (
          <JourneySummary
            flightsJourneySummary={flightsJourneySummary}
            flightsJourneyPolicies={flightsJourneyPolicies}
          />
        )}
        {flightsJourneyInformation && flightsJourneyInformation.details && (
          <div className={toggleClassNames} data-test-id="show-details-link">
            <ToggleLink
              flightsToggle={flightsJourneyInformation.details}
              handleActionClick={handleActionClick}
              expandedLink={isOpen}
            />
          </div>
        )}
      </>
    );
  }

  return null;
});
